import { render, staticRenderFns } from "./Debug.html?vue&type=template&id=8a7cc870&scoped=true&"
import script from "./Debug.ts?vue&type=script&lang=ts&"
export * from "./Debug.ts?vue&type=script&lang=ts&"
import style0 from "./Debug.css?vue&type=style&index=0&id=8a7cc870&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a7cc870",
  null
  
)

export default component.exports